export default "__VITE_ASSET__gd_jz9ZG__"